module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero section-quote",
    attrs: {
      "id": "section-quote"
    }
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column box section is-5 has-text-centered section-quote-box"
  }, [_c('p', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_vm._v(_vm._s(_vm.quoteContent)), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "title": "Refresh quote"
    },
    on: {
      "click": function($event) {
        _vm.refreshQuote()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "vertical-align": "middle"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.quoteContentUrl,
      "target": "_blank",
      "title": "Tweet this quote!"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    staticStyle: {
      "vertical-align": "middle"
    }
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79a11ac4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentQuoteSection.vue
// module id = 829
// module chunks = 1